import type { GetInstructorsUnapprovedResult } from '@features/instructors/api/get-instructors-unapproved/getInstructorsUnapproved.types';
import type { UseQueryResult } from '@tanstack/react-query';

import { getInstructorsUnapproved } from '@features/instructors/api/get-instructors-unapproved/getInstructorsUnapproved';
import { useQuery } from '@tanstack/react-query';

import type { UseInstructorsUnapprovedParams } from './useInstructorsUnapproved.types';

export function useInstructorsUnapproved(
  params: UseInstructorsUnapprovedParams
): UseQueryResult<GetInstructorsUnapprovedResult, Error> {
  return useQuery<GetInstructorsUnapprovedResult, Error>({
    queryKey: ['instructors', 'unapproved', params.customerId],
    queryFn: (): Promise<GetInstructorsUnapprovedResult> =>
      getInstructorsUnapproved(params.customerId),
    enabled: !!params.customerId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
}
